export default {
  /**
   * @param state
   * @param items
   */
  setTeacherIndividualEmployeeYearlyAttendanceList(state, items) {
    console.log("Items", items);

    state.items = items;
    console.log("Current State ", state);
  },

  /**
   * Change date filter
   *
   * @param state
   * @param currentDate
   */
  setTeacherIndividualEmployeeYearlyAttendanceDate(state, currentDate) {
    console.log("Current Date", currentDate);
    state.filter.date = currentDate;
  },
};
